(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["wishlist-button"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('wishlist-button-el')) {
    class WishlistButtonEl extends HTMLElement {
      connectedCallback() {
        this.productId = this.dataset.productId;
        this.button = this.querySelector('.wishlist-button__toggle');
        this.button.addEventListener('click', (event) => {
          event.preventDefault();
          this.toggle();
        });
        this.render();
      }

      getWishlist() {
        try {
          return JSON.parse(localStorage.getItem('theme:wishlist') || '[]');
        } catch (error) {
          return [];
        }
      }

      setWishlist(ids) {
        localStorage.setItem('theme:wishlist', JSON.stringify(ids));
      }

      toggle() {
        const ids = this.getWishlist();
        const index = ids.indexOf(this.productId);
        if (index > -1) {
          ids.splice(index, 1);
        } else {
          ids.push(this.productId);
        }
        this.setWishlist(ids);
        this.render();
      }

      render() {
        const active = this.getWishlist().includes(this.productId);
        this.button.setAttribute('aria-pressed', active ? 'true' : 'false');
      }
    }

    customElements.define('wishlist-button-el', WishlistButtonEl);
  }
  } catch(e) { console.error(e); }
})();

})();
